import { render, staticRenderFns } from "./WorkspaceTopBar.vue?vue&type=template&id=8d2e4f14&scoped=true&"
import script from "./WorkspaceTopBar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceTopBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceTopBar.vue?vue&type=style&index=0&id=8d2e4f14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2e4f14",
  null
  
)

export default component.exports